import { URI } from '@fiverr-private/futile/lib/url/URI';
import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import request from './request';
import localStorageService from './localStorage';

const deleteRecentlyViewedGigs = async() => {
    const url = new URI(pathfinder('clear_recently_viewed_gigs')).toString();

    try {
        await axios.delete(url);
    } catch (error) {
        logger.error(error);
    }
};

export default {
    fetch: ({ sortBy }, activeFilters, appContext) => {
        const gigIds = localStorageService.getRecentlyViewedGigs();
        const { showTranslatedUGC = false, knownCrawler, locale } = appContext;
        const translationUgcData = {
            session_locale: locale,
            showTranslatedUGC,
            knownCrawler,
            translate_ugc: showTranslatedUGC.toString()
        };

        return request.post('fetch_recently_viewed', { gig_ids: gigIds,
            sortBy,
            activeFilters,
            ...translationUgcData
        });
    },

    clearAllRecentlyViewedGigs: (loggedIn) => {
        if (loggedIn) {
            return deleteRecentlyViewedGigs();
        }

        return localStorageService.removeAllRecentlyViewedGigs();
    },

    clearRecentlyViewedGig: (loggedIn) => {

        if (loggedIn) {
            return undefined;
        }

        return localStorageService.removeSingleRecentlyViewedGig;
    },

    recentlyViewedPageURL: () => pathfinder('generic_recommendations_page', {
        page_name: 'recently_viewed_page'
    })
};
